import FixaSSRIcon from "../../../shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CheckmarkGreenSmallIconPath from "../../../shared/wrappers/FixaSSRIcon/paths/CheckmarkGreenSmallPath";
import NoticeRedSmallIconPath from "../../../shared/wrappers/FixaSSRIcon/paths/NoticeRedSmallIconPath";
import styles from "./task-notification.module.css";

export const TaskNotificationStatus = ({
  status,
}: {
  status: "COMPLETED" | "CLOSED";
}) => {
  return (
    <div className={styles["task-notification-item-body-status"] ?? ""}>
      {status === "COMPLETED" ? (
        <FixaSSRIcon paths={CheckmarkGreenSmallIconPath} />
      ) : (
        <FixaSSRIcon paths={NoticeRedSmallIconPath} />
      )}
    </div>
  );
};
